import { render, staticRenderFns } from "./QueueChunk.vue?vue&type=template&id=53478abf&"
import script from "./QueueChunk.vue?vue&type=script&lang=ts&"
export * from "./QueueChunk.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports